export const CREATE_DOCUMENT = 'CREATE_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS';

export const filterOptions = [
  {
    key: 'all',
    text: 'All Documents',
    value: 'getDocumentsForDashboard',
  },
  {
    key: 'bhp-docs',
    text: 'BHP Documents',
    value: 'getBhpDocumentsForDashboard',
  },
  {
    key: 'bhp-review',
    text: 'BHP Performance Reviews',
    value: 'getBhpReviewDocumentsForDashboard',
  },
  {
    key: 'comp',
    text: 'Comp Assessments - Portal',
    value: 'getCompDocumentsForDashboard',
  },
  {
    key: 'comp-drive',
    text: 'Comp Assessments - Drive',
    value: 'getPdfCompDocumentsForDashboard',
    icon: 'google drive',
  },
  {
    key: 'crisis',
    text: 'Crisis Plans - Portal',
    value: 'getCrisisDocumentsForDashboard',
  },
  {
    key: 'crisis-drive',
    text: 'Crisis Plans - Drive',
    value: 'getPdfCrisisDocumentsForDashboard',
    icon: 'google drive',
  },
  {
    key: 'emergency',
    text: 'Emergency Contacts',
    value: 'getEmergencyDocumentsForDashboard',
  },
  {
    key: 'incident',
    text: 'Incident Reports',
    value: 'getIncidentDocumentsForDashboard',
  },
  {
    key: 'release',
    text: 'Releases - Portal',
    value: 'getReleaseDocumentsForDashboard',
  },
  {
    key: 'release-drive',
    text: 'Releases - Drive',
    value: 'getPdfReleaseDocumentsForDashboard',
    icon: 'google drive',
  },
  {
    key: 'vineland',
    text: 'Vinelands',
    value: 'getVinelandDocumentsForDashboard',
  },
];
